import React, { useState } from "react";
import "./Career.css";

const Careers = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");

  // Open modal with role
  const handleApply = (role) => {
    setSelectedRole(role);
    setOpenModal(true);
  };

  return (
    <section className="careers" id ="career">
      {/* JOB CARDS */}
  <div className="career-header">
  <h1>Careers</h1>
  <p>Join our team and grow with us in the real estate industry</p>
</div>
    <div className="career-jobs">

  {/* SALES */}
  <div className="job-card">
    <h2>Sales Executive</h2>
    <p className="job-location">📍 Bangalore | Full-Time</p>

    <ul>
      <li>Handle customer inquiries and site visits</li>
      <li>Explain project details and pricing</li>
      <li>Convert leads into successful sales</li>
      <li>Build strong client relationships</li>
      <li>Achieve monthly sales targets</li>
    </ul>

    <button onClick={() => handleApply("Sales Executive")}>
      Apply Now
    </button>
  </div>

  {/* PRE-SALES */}
  <div className="job-card">
    <h2>Pre-Sales Executive</h2>
    <p className="job-location">📍 Bangalore | Full-Time</p>

    <ul>
      <li>Handle inbound and outbound calls</li>
      <li>Explain project details to customers</li>
      <li>Generate and qualify leads</li>
      <li>Schedule site visits for sales team</li>
      <li>Maintain customer database and follow-ups</li>
    </ul>

    <button onClick={() => handleApply("Pre-Sales Executive")}>
      Apply Now
    </button>
  </div>

</div>

      {/* 🔥 MODAL */}
      {openModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            {/* CLOSE */}
            <span className="close-btn" onClick={() => setOpenModal(false)}>
              ✕
            </span>

            <h2>Apply Now</h2>

            <form>
  <input type="text" placeholder="Full Name" required />
  <input type="email" placeholder="Email Address" required />
  <input type="tel" placeholder="Phone Number" required />

  {/* ROLE */}
  <select
    value={selectedRole}
    onChange={(e) => setSelectedRole(e.target.value)}
  >
    <option value="">Select Position</option>
    <option value="Sales Executive">Sales Executive</option>
    <option value="Pre-Sales Executive">Pre-Sales Executive</option>
  </select>

  <textarea placeholder="Your Experience"></textarea>

  {/* 🔥 CV UPLOAD */}
  <div className="file-upload">
    <label>Upload CV / Resume</label>
    <input
      type="file"
      accept=".pdf,.doc,.docx"
      required
    />
  </div>

  <button type="submit">Submit Application</button>
</form>
          </div>
        </div>
      )}
    </section>
  );
};

export default Careers;
